import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { withTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { connect, useDispatch } from 'react-redux';
import { closeOverlay } from '../../actions/overlay';
import { startChangingPassword } from '../../actions/user';
import { LoadingSpinnerSmall } from '../loading-spinner';
import CustomConfirmOverlay from '../overlay-custom-confirm';
import SetPasswordView from '../view-set-password';
import { ConfirmTextContainer, SetPasswordSubTitle } from './styles';
const conditions = (password, confirmPassword) => ({
  atLeast8Characters: password.length >= 8,
  atLeastOneLowercase: password.match(/[a-z]/),
  atLeastOneUppercase: password.match(/[A-Z]/),
  atLeastOneNumber: password.match(/\d+/),
  samePassword: password && confirmPassword && password === confirmPassword
});
const findCondError = condObj => {
  return Object.values(condObj).filter(x => !x).length > 0;
};
const SetPasswordOverlay = _ref => {
  let {
    passwordChangeSuccess,
    startChangingPassword,
    passwordChangeError,
    passwordChangeLoading
  } = _ref;
  const dispatch = useDispatch();
  const [state, setState] = React.useState({
    password: '',
    confirmPassword: ''
  });
  const {
    password,
    confirmPassword
  } = state;
  const conds = conditions(password, confirmPassword);
  const handleCloseModal = () => {
    dispatch(closeOverlay());
  };
  const goToLogin = () => {
    window.location.pathname = '/login';
  };
  return /*#__PURE__*/React.createElement(Fragment, null, passwordChangeSuccess ? /*#__PURE__*/React.createElement(CustomConfirmOverlay, {
    title: "Mot de passe modifi\xE9",
    body: /*#__PURE__*/React.createElement("p", null, "Votre mot de passe a \xE9t\xE9 modifi\xE9. ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("b", null, "Connectez-vous.")),
    handleConfirm: goToLogin,
    confirmText: "Connexion",
    confirmActionOnly: true,
    handleReject: handleCloseModal
  }) : /*#__PURE__*/React.createElement(CustomConfirmOverlay, {
    title: "Mot de passe",
    body: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SetPasswordSubTitle, null, "Votre mot de passe doit contenir au moins 8 ", /*#__PURE__*/React.createElement("br", null), " caract\xE8res, une majuscule, ", /*#__PURE__*/React.createElement("br", null), " une minuscule et un chiffre."), /*#__PURE__*/React.createElement(SetPasswordView, {
      state: state,
      setState: setState,
      error: passwordChangeError
    })),
    handleConfirm: () => startChangingPassword(password),
    confirmText: /*#__PURE__*/React.createElement(ConfirmTextContainer, null, "Valider", passwordChangeLoading && /*#__PURE__*/React.createElement(LoadingSpinnerSmall, {
      size: 15,
      borderWidth: 2
    })),
    confirmDisabled: findCondError(conds),
    rejectIcon: faTimes,
    handleReject: handleCloseModal
  }));
};
const mapStateToProps = _ref2 => {
  let {
    user
  } = _ref2;
  return {
    passwordChangeError: user.passwordChangeError,
    passwordChangeLoading: user.passwordChangeLoading,
    passwordChangeSuccess: user.passwordChangeSuccess
  };
};
const mapDispatchToProps = dispatch => ({
  startChangingPassword: pwd => dispatch(startChangingPassword(pwd))
});
SetPasswordOverlay.propTypes = {
  startChangingPassword: PropTypes.func.isRequired,
  passwordChangeError: PropTypes.object,
  passwordChangeLoading: PropTypes.bool.isRequired,
  passwordChangeSuccess: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(withTheme(SetPasswordOverlay));